<success-screen class="bp-modal">
	<bp-modal-header header [title]="header"></bp-modal-header>
	<div content class="success-content-inner bp-modal-body">
		<div class="card-deposit-pending-content">
			<loading-spinner class="green loader-big no-padding"></loading-spinner>
			<p class="card-deposit-pending-description">{{ descriptionKey$ | async | translate }}</p>
		</div>
	</div>
</success-screen>
